import OffsetPaginationMetaSchema from "@/schemas/OffsetPaginationSchema";
import { array, assign, object } from "superstruct";

import GiftRegistryItemSchema from "./GiftRegistryItemSchema";

const GiftRegistryItemsResponseSchema = assign(
    OffsetPaginationMetaSchema,
    object({
        items: array(
            object({
                giftRegistryItem: GiftRegistryItemSchema,
            })
        ),
    })
);

export default GiftRegistryItemsResponseSchema;
